import ViewingMode from 'shared/components/viewing-mode-controller/types/viewing-mode';
import OrganisationTreeNode from 'shared/features/organisation/models/organisation-tree-node';

export default class EmergencyAlarmRouteValidator {
  static checkSingleEmergencyAlarmRouteRule(
    viewingMode: ViewingMode,
    parentNode: OrganisationTreeNode | undefined,
    selectedNode: OrganisationTreeNode | undefined,
    upstreamParentBranch: OrganisationTreeNode[],
  ): boolean {
    if (
      !parentNode?.id ||
      (!this.hasEmergencyAlarmRouteRuleInParents(parentNode.id, upstreamParentBranch) &&
        !this.hasEmergencyAlarmRouteRuleInChildren(viewingMode === 'editing' ? selectedNode?.childOrganisationUnits : undefined))
    ) {
      return true;
    }

    return false;
  }

  private static hasEmergencyAlarmRouteRuleInChildren(childOrganisationUnits: OrganisationTreeNode[] | undefined): boolean {
    if (!childOrganisationUnits) {
      return false;
    }

    let anyChildHasEmergencyAlarmRouteRule = false;
    for (const child of childOrganisationUnits) {
      if (child.hasAlternativeEmergencyAlarmRouteOrganisationUnits) {
        anyChildHasEmergencyAlarmRouteRule = true;
        break;
      }

      if (this.hasEmergencyAlarmRouteRuleInChildren(child.childOrganisationUnits)) {
        anyChildHasEmergencyAlarmRouteRule = true;
        break;
      }
    }
    return anyChildHasEmergencyAlarmRouteRule;
  }

  private static hasEmergencyAlarmRouteRuleInParents(parentId: string | undefined, upstreamParentBranch: OrganisationTreeNode[]): boolean {
    if (!parentId) {
      return false;
    }

    const parent = upstreamParentBranch.find((node) => node.id === parentId);
    if (parent?.hasAlternativeEmergencyAlarmRouteOrganisationUnits) {
      return true;
    } else if (parent?.isLocation) {
      return false;
    }

    return this.hasEmergencyAlarmRouteRuleInParents(parent?.parentId, upstreamParentBranch);
  }

  static hasLocationInParents(parentId: string | undefined, upstreamParentBranch: OrganisationTreeNode[]): boolean {
    if (!parentId) {
      return false;
    }
    const parent = upstreamParentBranch.find((node) => node.id === parentId);
    if (parent?.isLocation) {
      return true;
    }

    return this.hasLocationInParents(parent?.parentId, upstreamParentBranch);
  }
}
